export default class ExtensionInfoItemNoteModel {
  public extensionInfoItemNoteId: string = ''
  public extensionInfoItemId: string = ''
  public extensionInvestigationId: string = ''
  public notes: string = ''

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
